import { formatAbsolute, formatRelative } from "../lib/format";
import { useNowTick } from "../lib/now";

/**
 * Relative time with the absolute instant as a tooltip. Re-renders on the shared 30-second tick so a
 * dashboard left open keeps counting. `now`/`zone` exist for tests; the app leaves them unset.
 */
export function Timestamp({ at, zone, now, className }: { at: string | null; zone?: string; now?: Date; className?: string }) {
  useNowTick();
  if (at === null) return <span className={className} aria-label="none yet">—</span>;
  return <time dateTime={at} title={formatAbsolute(at, zone)} className={className}>{formatRelative(at, now ?? new Date(), zone)}</time>;
}
